module.exports = __webpack_public_path__ + "img/Arpit.4023f180.jpg";